/* eslint-disable max-len */
import React, { Component } from 'react';
import { Field } from 'redux-form';
import { injectIntl } from 'react-intl';
import validators from '../../shared/validators';

import FormField from '../shared/form-field';
import CreditCard from '../../../services/credit-card';

class CardFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ccType: 'generic',
        };
    }

    onCCNumberChange(e) {
        this.setState({
            ccType: CreditCard.ccType(e.target.value),
        });
        this.props.onInputChangeHandler(e);
    }

    render() {
        return (
            <div className="" id="PaymentForm">
                <Field
                    className="form-control"
                    name="order[payments_attributes][0][source_attributes][name]"
                    component={FormField.inputFieldMarkup}
                    label={this.props.intl.formatMessage({ id: 'nameOnCard', defaultMessage: 'Name on card' })}
                    onChange={this.props.onInputChangeHandler}
                    onFocus={this.props.onInputFocus}
                    type="text"
                    validate={validators.required}
                />

                <div className="cc-number-wrapper">
                    <div className="cc-number-wrapper__input">
                        <Field
                            className="form-control"
                            name="order[payments_attributes][0][source_attributes][number]"
                            component={FormField.inputFieldMarkup}
                            label={this.props.intl.formatMessage({ id: 'cardNumber', defaultMessage: 'Card Number' })}
                            onChange={(e) => {
                                this.onCCNumberChange(e);
                            }}
                            onFocus={this.props.onInputFocus}
                            defaultValue={this.props['order[payments_attributes][0][source_attributes][number]']}
                            type="tel"
                            validate={validators.required}
                        />
                    </div>
                    <div className="cc-number-wrapper__card-logo">
                        <img src={`/pay-types/${this.state.ccType}-logo.png`} alt="CC logo" />
                    </div>
                </div>

                <Field
                    className="form-control"
                    name="order[payments_attributes][0][source_attributes][expiry]"
                    component={FormField.inputFieldMarkup}
                    label={this.props.intl.formatMessage({ id: 'cardExpiration', defaultMessage: 'Card Expiration' })}
                    placeholder={this.props.intl.formatMessage({ id: 'card-expiry-placeholder', defaultMessage: 'Expiration' })}
                    onChange={this.props.onInputChangeHandler}
                    onFocus={this.props.onInputFocus}
                    defaultValue={this.props['order[payments_attributes][0][source_attributes][expiry]']}
                    type="tel"
                    validate={validators.required}
                />

                <Field
                    className="form-control"
                    name="order[payments_attributes][0][source_attributes][verification_value]"
                    component={FormField.inputFieldMarkup}
                    label="CVV*"
                    placeholder={this.props.intl.formatMessage({ id: 'security-digits', defaultMessage: 'Security digits' })}
                    onChange={this.props.onInputChangeHandler}
                    onFocus={this.props.onInputFocus}
                    defaultValue={this.props['order[payments_attributes][0][source_attributes][verification_value]']}
                    type="tel"
                    validate={validators.required}
                />
            </div>
        );
    }
}

export default injectIntl(CardFields);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/payment/card-fields.jsx
 **/